var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.1667C4.04665 15.1667 0.833313 11.9533 0.833313 8.00001C0.833313 4.04668 4.04665 0.833344 7.99998 0.833344C11.9533 0.833344 15.1666 4.04668 15.1666 8.00001C15.1666 11.9533 11.9533 15.1667 7.99998 15.1667ZM7.99998 1.83334C4.59998 1.83334 1.83331 4.60001 1.83331 8.00001C1.83331 11.4 4.59998 14.1667 7.99998 14.1667C11.4 14.1667 14.1666 11.4 14.1666 8.00001C14.1666 4.60001 11.4 1.83334 7.99998 1.83334Z",
    fill: "#F93232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1129 10.3867C5.98623 10.3867 5.85956 10.3401 5.75956 10.2401C5.56623 10.0467 5.56623 9.72675 5.75956 9.53341L9.5329 5.76008C9.72623 5.56675 10.0462 5.56675 10.2396 5.76008C10.4329 5.95342 10.4329 6.27341 10.2396 6.46675L6.46623 10.2401C6.3729 10.3401 6.23956 10.3867 6.1129 10.3867Z",
    fill: "#F93232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88623 10.3867C9.75956 10.3867 9.6329 10.3401 9.5329 10.2401L5.75956 6.46675C5.56623 6.27341 5.56623 5.95342 5.75956 5.76008C5.9529 5.56675 6.2729 5.56675 6.46623 5.76008L10.2396 9.53341C10.4329 9.72675 10.4329 10.0467 10.2396 10.2401C10.1396 10.3401 10.0129 10.3867 9.88623 10.3867Z",
    fill: "#F93232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.59cace57b29da95e324c1d64cd6a82a7.svg";
export { ForwardRef as ReactComponent };